import React, { useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Divider,
  Button,
  Box,
  DialogActions,
  IconButton,
} from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import appLogo from "../../assets/images/header-footer/app-logo.png";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close"; 

const PaymentDialogue = ({ onClose, paymentDetails, showPaymentModal }) => {
  const dialogRef = useRef(null);

  const timestamp = paymentDetails?.transactionTime; // This is a string
  const date = new Date(timestamp); // Convert string to Date object

  const formattedDateTime = date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });


  // Function to download as PDF
  const handleDownloadPDF = () => {
    if (dialogRef.current) {
      const pdf = new jsPDF("p", "mm", "a4");
      html2canvas(dialogRef.current).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 190;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 10;

        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save("payment_receipt.pdf");
      });
    }
  };

  // Function to save as image
  const handleSaveImage = () => {
    if (dialogRef.current) {
      html2canvas(dialogRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "payment_receipt.png";
        link.click();
      });
    }
  };

  return (
    <Dialog open={showPaymentModal} onClose={onClose} maxWidth="xs" fullWidth>
      <Box ref={dialogRef}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          <Box
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <img src={appLogo} height={50} width={120} alt="app logo" />
          </Box>
          {/* Close Button */}
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogTitle
          align="center"
          sx={{ fontSize: "24px", fontFamily: "Tajawal-Regular" }}
        >
          ✅ Successfully Paid
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
          {/* <Box sx={{justifyContent:"center", alignItems:"center"}}> */}
          <Typography variant="h5" fontWeight="bold" align="center">
           {paymentDetails?.paidCurrency} {paymentDetails?.paidAmount}
          </Typography>
          <Divider sx={{ my: 2 }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            mb={1}
          >
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              <strong>Transaction ID</strong>
            </Typography>
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              {paymentDetails?.transactionId}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            mb={1}
          >
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              <strong>Transaction Time</strong>
            </Typography>
            <Typography>{formattedDateTime}</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            mb={1}
          >
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              <strong>Payment Method</strong>
            </Typography>
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              {paymentDetails?.paymentMethod}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            mb={1}
          >
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              <strong>Customer Name</strong>
            </Typography>
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              {paymentDetails?.customerName}
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box
            sx={{
              backgroundColor: "#f8f8f8",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
              >
                <strong>Invoice Amount</strong>
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  fontFamily: "Tajawal-Regular",
                }}
              >
               {Number(paymentDetails?.paidAmount).toFixed(2)}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
              >
                <strong>Service Charges</strong>
              </Typography>
              <Typography
                sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
              >
                {paymentDetails?.serviceCharges}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ my: 1 }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              backgroundColor: "#f8f8f8",
              borderRadius: "8px",
              padding: "12px",
              my: 1,
            }}
          >
            <Typography
              sx={{ fontSize: "20px", fontFamily: "Tajawal-Regular" }}
            >
              <strong>Total Amount</strong>{" "}
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontFamily: "Tajawal-Regular",
                fontSize: "20px",
              }}
            >
              {" "}
              {(paymentDetails?.paidAmount + paymentDetails?.serviceCharges).toFixed(2)}
            </Typography>
          </Box>

          {/* </Box> */}
        </DialogContent>
      </Box>
      <DialogActions>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* PDF Button */}
          <Button
            sx={{
              background:
                "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
              color: "white",
              borderTopLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              fontFamily: "Tajawal-Bold",
              padding: "12px 12px",
              textAlign: "center",
              width: "200px",
            }}
            startIcon={<PictureAsPdfIcon />}
            onClick={handleDownloadPDF}
          >
            Save to PDF
          </Button>

          {/* Image Button */}
          <Button
            sx={{
              background:
                "linear-gradient(90deg, #004D8A 0%, #02599C 20.9%, #0886E1 73.48%, #0A91F2 97.3%)",
              color: "white",
              borderTopLeftRadius: "16px",
              borderBottomRightRadius: "16px",
              fontFamily: "Tajawal-Bold",
              padding: "12px 12px",
              textAlign: "center",
              marginLeft: "5%",
              width: "200px",
            }}
            startIcon={<ImageIcon />}
            onClick={handleSaveImage}
          >
            Save to Gallery
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialogue;
